import _objectSpread from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//

import Contents from "./DialogComponents/index";
export default {
  name: "",
  components: _objectSpread({}, Contents),
  props: {
    title: String,
    name: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: "60%"
    },
    contentPropsData: Object
  },
  data: function data() {
    return {
      visible: false
    };
  },
  computed: {},
  watch: {},
  mounted: function mounted() {},
  methods: {
    show: function show(_ref) {
      var _this = this;
      var methods = _ref.methods;
      this.visible = true;
      this.$nextTick(function () {
        for (var key in methods) {
          if (!methods.hasOwnProperty) return;
          console.log(_this.$refs.content);
          _this.$refs.content.$on(key, methods[key]);
        }
      });
    },
    hide: function hide() {
      this.visible = false;
    },
    closed: function closed() {
      this.$destroy();
    }
  }
};